<template>
  <div class="price-block-items">
    <b-field
      grouped
      :class="'price-items price-items-' + index"
    >

      <b-field
        label="Description"
        class="price-item-description"
        custom-class="is-size-6 has-text-weight-normal price-form-item"
      >
        <b-input
          v-model="item.description"
          maxlength="100"
          ref="inputDescription"
          @blur="handleBlur"
        >
        </b-input>
      </b-field>

      <b-field label="Quantity"
               class="price-item-quantity"
               custom-class="is-size-6 has-text-weight-normal price-form-item"
      >
        <CustomInput
          v-model="item.quantity"
          :mask="maskQuantity"
          :placeholder="`0.00`"
          inputmode="decimal"
          :selectonfocus='`all`'
          @getRawValue="handleUpdate('quantity', $event)"
          class="input-text-right"
        />
      </b-field>

      <b-field
        label="Unit price"
        class="price-item-price"
        custom-class="is-size-6 has-text-weight-normal price-form-item"
      >
        <CustomInput
          v-model="item.unitPrice"
          :mask="maskUnitPrice"
          :placeholder="`$0.00`"
          inputmode="decimal"
          :selectonfocus='`withoutPrefix`'
          @getRawValue="handleUpdate('unitPrice', $event)"
          class="input-text-right"
        />
      </b-field>

      <b-field
        label="Total price"
        class="price-item-total"
        custom-class="is-size-6 has-text-weight-normal price-form-item"
      >
        <b-input
          :value="totalItemPrice()"
          readonly>
        </b-input>
      </b-field>

      <b-field
        class="price-item-delete"
        custom-class="is-size-6 has-text-weight-normal"
      >
        <b-button
          @click="removeItem(index)"
          type="is-success is-medium is-ghost"
          :class="index > 0 ? 'btn-delete-12' : 'btn-delete-4'"
        >
          <b-icon icon="delete" type=""></b-icon>
        </b-button>
      </b-field>

    </b-field>
  </div>
</template>

<script>
import CustomInput from '@/components/CustomInput.vue';

export default {
  name: 'PriceFormItem',
  components: {
    CustomInput,
  },
  props: {
    item: {
      type: Object,
      default: null,
    },
    index: {
      type: Number,
      default: null,
    },
    indexItem: {
      type: Number,
      default: null,
    },
    calculateTotalPrice: Function,
    deleteItem: Function,
  },
  data() {
    return {
      maskQuantity: {
        numeral: true,
        numeralThousandsGroupStyle: 'thousand',
        numeralDecimalScale: 2,
        numeralIntegerScale: 5,
        numeralPositiveOnly: true,
      },
      maskUnitPrice: {
        numeral: true,
        numeralThousandsGroupStyle: 'thousand',
        numeralDecimalScale: 2,
        numeralIntegerScale: 6,
        numeralPositiveOnly: true,
        prefix: '$',
      },
    };
  },
  mounted() {
  },
  methods: {
    setFocus() {
      this.$refs.inputDescription.focus();
    },
    removeItem(index) {
      this.deleteItem(index);
    },
    handleBlur() {
      this.item.description = this.item.description.trim().replace(/ {2,}/g, ' ');
    },
    totalItemPrice() {
      return this.calculateTotalPrice(this.item);
    },
    handleUpdate(field, rawValue) {
      if (this.item && Object.prototype.hasOwnProperty.call(this.item, field)) {
        this.item[`${field}Raw`] = rawValue;
      }
    },
  },
};
</script>

<style lang="stylus">

@import "~@/assets/style/variables.styl";

.price-block-items
  width: 100%;

  .buttons
    margin-top 15px

  .button.is-success.is-ghost
    border none
    background-color transparent
    color #68ba62

  .button.is-success.is-ghost:hover
    color #23d160
    background-color transparent

  .button.is-success.is-ghost:focus:not(:active)
    box-shadow: none

  .field.is-grouped .field:not(:last-child)
    margin 0

  @media (max-width: 899px) // Mobile

    .price-items
      padding 10px
      margin-top 10px
      display flex
      flex-direction row
      flex-wrap wrap
      justify-content space-between
      background-color #f4f7f8
      .input-text-right
        text-align right
        .input
          text-align right

    .price-item-description
      width 100%

    .price-item-quantity
      width calc(50% - 5px)
      padding-right 10px

    .price-item-price
      width calc(50% + 5px)
      padding-left 10px

    .price-item-total
      width calc(100% - 40px)
      display flex
      align-items center
      justify-content flex-start
      .label
        margin 0
        text-wrap nowrap
        white-space nowrap
        &::after
          content ":"
      .input
        background-color transparent
        border none

    .price-item-delete
      width calc(40px)
      text-align right
      .button
        height 100%

  @media (min-width: 900px)

    .btn-delete-12
      margin-top -12px

    .btn-delete-4
      padding-top 12px

    .price-items-0
      .label
        display block !important

    .price-items
      width 100%
      display flex
      flex-direction row
      flex-wrap nowrap
      justify-content space-between
      .has-text-weight-normal.price-form-item
        color #969ea2

      .label
        display none
        text-align left

      .price-item-description
        width 60%

        .input
          border-top-right-radius 0
          border-bottom-right-radius 0
          border-right none

      .input-text-right
        text-align right
        .input
          text-align right

      .price-item-quantity
        width 10%
        text-align right

        .input
          border-radius 0
          border-right none

      .price-item-price
        width 12%
        text-align right

        .input
          border-radius 0
          border-right none

      .price-item-total
        width 18%
        .input
          border-top-left-radius 0
          border-bottom-left-radius 0
          background-color enh-color-gray-input
          text-align right

      .price-item-delete
        width 40px
        text-align right

        .button
          height 100%
</style>
